import { client } from "../supabase";
import { buildContextoCobro, buildCobroPorVenta } from "./getCobroFactura";

/**
 * Carga toda la data de cobro (los 4 caminos de getCobroReal) + el conector venta↔factura SII, y
 * devuelve el mapa `cobroPorVenta` keyado por `${venta_tipo}:${venta_ref_id}:${venta_ref_index??""}`.
 *
 * Es la fuente de "recaudada" para el motor de comisión de edificios (sales + sales_contratos),
 * que antes leía `sales.facturafechacobro` crudo (que el cobro SII nunca puebla → facturas
 * cobradas figuraban Pendiente, Bug B). Resuelve la cobranza a nivel factura SII (uniforme para
 * los 4 modelos) y la expone por venta para que el motor la consuma sin reescribir su lógica.
 */
export const cargarCobroPorVenta = async (pais) => {
  const [vinc, fact, mbf, movB, opF, opFF, plan] = await Promise.all([
    client
      .from("facturas_sii_vinculaciones")
      .select("venta_tipo, venta_ref_id, venta_ref_index, factura_sii_emitida_id"),
    client.from("facturas_sii_emitidas").select("id, monto_total, estado_factoring").eq("pais", pais),
    client.from("movimiento_bancario_facturas").select("factura_tipo, factura_id, monto, movimiento_bancario_id"),
    // Solo id + fecha: el resolver usa el movimiento únicamente para datar la vía MBF (B3 Fase A retiró
    // el fallback por FK directa `factura_sii_emitida_id`).
    client.from("movimientos_bancarios").select("id, fecha").eq("pais", pais),
    client
      .from("operaciones_factoring")
      .select("id, estado, fecha_pago_real, fecha_cobro_final, fecha_operacion, factura_sii_emitida_id"),
    client.from("operaciones_factoring_facturas").select("operacion_factoring_id, factura_sii_emitida_id"),
    client
      .from("plan_cobros_facturas")
      .select("factura_sii_emitida_id, estado, fecha_cobro_real, fecha_vencimiento")
      .eq("pais", pais),
  ]);

  const ctx = buildContextoCobro({
    mbfRows: mbf.data || [],
    movimientosBancarios: movB.data || [],
    facturasEmitidas: fact.data || [],
    operacionesFactoring: opF.data || [],
    operacionesFactoringFacturas: opFF.data || [],
    planCuotas: plan.data || [],
  });

  // Solo vinculaciones cuya factura es de este país (las demás resolverían a no-cobrada por no
  // estar en el ctx; se descartan para no ensuciar el mapa con keys de otros países).
  const idsPais = new Set((fact.data || []).map((f) => f.id));
  const vinculaciones = (vinc.data || []).filter((v) => idsPais.has(v.factura_sii_emitida_id));

  return buildCobroPorVenta(vinculaciones, ctx);
};
